// noinspection JSUnusedGlobalSymbols

export const RevenueCat = {
  logOut: async () => {
    if (__DEV__) {
      console.debug('[revcat] logOut called on web - no-op')
    }

    return Promise.resolve()
  }
}
